import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export function useUpdateTemplateMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: (template: Api.ITemplate) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
} = {}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({
			template,
			impersonationContext,
		}: {
			template: Api.ITemplate | Api.ISocialMediaPostTemplate;
			impersonationContext?: Api.IImpersonationContext;
		}) => {
			// A generic update binds the base model, so it cannot see the versions and an edit would drop
			// them. The typed route also stamps the discriminator, upgrading a template stored before the
			// subclass existed.
			const isSocial =
				template?.templateType === Api.TemplateType.SocialMediaPost && template?.scope !== Api.TemplateScope.Industry;
			return userSession.webServiceHelper.callAsync(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: isSocial
						? `template/social/${encodeURIComponent(template.id)}`
						: `template/${encodeURIComponent(template.id)}`,
					impersonationContext,
				}),
				isSocial ? `PUT` : `PATCH`,
				template
			);
		},
		onError,
		onSuccess,
	});
}
